// eslint-disable-next-line import/prefer-default-export
export const HS_ROLES = [
  'admin', 'member',
];
